import FormField from "../../../common/forms/FormField";
import { StepFormStyle } from "../ApiPage";
import { categories, fieldNameEnums } from "../apiPageHelper";
import info from "../../../../assets/icons/info-circle-white.svg";
import { Fragment, useState } from "react";
import ArrayFields from "./ArrayFields";

const TestConnectionPopup = ({
    getFieldsByCategory,
    updatePopField,
    isSuccess,
    testConnectionLoader,
    stepsWithAuth = [],
    dropDownData = [],
    testApiData = []
}) => {
    // #region STATES
    const [dataTypes] = useState([
        { value: "String", name: "String" },
        { value: "Number", name: "Number" },
        { value: "Boolean", name: "Boolean" },
        { name: "Array Fields", value: "Array Fields" }
    ]);

    // #endregion
    // #region VARS
    const fieldName = isSuccess ? fieldNameEnums.RETURN_VALUE : fieldNameEnums.FIELD_VALUE;
    const title = isSuccess ? "Returned Value" : "Field Value";
    const hasValue = field => {
        const keysToCheck = [
            "type",
            "value",
            "predefinedValue",
            "fieldValue",
            "returnValue",
            "connectFieldName",
            "extraFieldName"
        ];
        return keysToCheck?.some(key => field[key] && field[key].toString().trim() !== "");
    };
    // #endregion

    return (
        <div className="pos-dialog-card mb-16px" style={{ height: isSuccess ? "auto" : "530px", overflowY: "auto" }}>
            {stepsWithAuth?.map((step, stepIndex) => {
                if (step?.returnType === "Array" && isSuccess) {
                    return (
                        <pre
                            key={stepIndex}
                            style={{
                                background: "transparent",
                                color: "#fff",
                                padding: "12px",
                                borderRadius: "8px",
                                fontSize: "13px",
                                maxHeight: "400px",
                                overflowY: "auto"
                            }}>
                            {testApiData}
                        </pre>
                    );
                }

                return (
                    <StepFormStyle key={stepIndex}>
                        <div className="frame-100001139010">
                            {Object.entries(categories)?.map(([category, label]) => {
                                const shouldShow = isSuccess
                                    ? category === "returnFields"
                                    : category !== "returnFields";

                                if (!shouldShow) return null;
                                const fields = getFieldsByCategory(step, category)?.filter(hasValue);
                                if (!fields?.length) return null;
                                return (
                                    <div
                                        key={category}
                                        className="frame-1000011384"
                                        style={{
                                            minHeight: "100px",
                                            maxHeight: "300px",
                                            overflowY: "auto"
                                        }}>
                                        <div className="frame-1000011382">
                                            <div className="frame-295922385">
                                                <div className="frame-295922380">
                                                    <div className="frame-161">
                                                        <div className="frame-296">
                                                            <div className="header-fields">{label}</div>
                                                            <img className="info-circle9" src={info} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="frame-2959223813">
                                                    <div className="frame-271">
                                                        <div className="frame-291">
                                                            <div className="frame-171">
                                                                <div className="frame-144"></div>
                                                            </div>
                                                        </div>
                                                        <div className="frame-1588">
                                                            {fields?.map((field, index) => {
                                                                return (
                                                                    <Fragment key={field.id || index}>
                                                                        <div className="frame-902 p-relative">
                                                                            <div className="dropdown-selector2 input-width">
                                                                                <FormField
                                                                                    type="dropdown"
                                                                                    title="Type"
                                                                                    tooltip="Type"
                                                                                    dropdownData={dataTypes}
                                                                                    value={field?.type}
                                                                                    requiredType="locked"
                                                                                    assistiveText=""
                                                                                    varName="type"
                                                                                />
                                                                            </div>
                                                                            <div className="simple input-width">
                                                                                <FormField
                                                                                    type="text"
                                                                                    title="Name"
                                                                                    tooltip="Name"
                                                                                    requiredType="locked"
                                                                                    assistiveText=""
                                                                                    varName="name"
                                                                                    value={field?.name}
                                                                                />
                                                                            </div>
                                                                            <div className="dropdown-selector2 input-width">
                                                                                <FormField
                                                                                    className="w-100"
                                                                                    type="dropdown"
                                                                                    title="Value"
                                                                                    tooltip="Value"
                                                                                    dropdownData={
                                                                                        dropDownData ||
                                                                                        field?.options ||
                                                                                        []
                                                                                    }
                                                                                    dropdownSettings={{
                                                                                        hasLockedFields: true
                                                                                    }}
                                                                                    requiredType="locked"
                                                                                    assistiveText=""
                                                                                    varName="value"
                                                                                    value={
                                                                                        field?.connectFieldName ||
                                                                                        field?.value ||
                                                                                        field?.extraFieldName
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            {field?.value === "Predefined" ||
                                                                            field?.predefinedValue ? (
                                                                                <div className="dropdown-selector5 input-width">
                                                                                    <FormField
                                                                                        type="text"
                                                                                        title="Predefined Value"
                                                                                        tooltip="Predefined Value"
                                                                                        requiredType="locked"
                                                                                        assistiveText=""
                                                                                        varName="predefinedValue"
                                                                                        value={field?.predefinedValue}
                                                                                    />
                                                                                </div>
                                                                            ) : null}
                                                                            {!field?.predefinedValue && (
                                                                                <div className="dropdown-selector5 input-width">
                                                                                    <FormField
                                                                                        type="text"
                                                                                        title={title}
                                                                                        tooltip={title}
                                                                                        requiredType={
                                                                                            isSuccess ||
                                                                                            testConnectionLoader
                                                                                                ? "locked"
                                                                                                : "mandatory"
                                                                                        }
                                                                                        assistiveText=""
                                                                                        varName={fieldName}
                                                                                        value={
                                                                                            field?.fieldValue ||
                                                                                            field?.returnValue
                                                                                        }
                                                                                        onTextChange={e => {
                                                                                            updatePopField(
                                                                                                stepIndex,
                                                                                                fieldName,
                                                                                                e,
                                                                                                field.id
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        {field.type === "Array Fields" && (
                                                                            <>
                                                                                {field?.arrayFields?.map(subField => {
                                                                                    return (
                                                                                        <ArrayFields
                                                                                            key={subField.id}
                                                                                            subField={subField}
                                                                                            stepIndex={stepIndex}
                                                                                            dataTypes={dataTypes}
                                                                                            updateArraySubField={() => {}}
                                                                                            parentFieldId={field.id}
                                                                                            dropdownData={
                                                                                                dropDownData ||
                                                                                                field?.option ||
                                                                                                []
                                                                                            }
                                                                                            parentField={field}
                                                                                            removeArraySubField={() => {}}
                                                                                            handleOpenConnectedFieldModal={() => {}}
                                                                                            isTestConnection={true}
                                                                                            updatePopField={
                                                                                                updatePopField
                                                                                            }
                                                                                            isSuccess={isSuccess}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </>
                                                                        )}
                                                                    </Fragment>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="line-4"></div>
                                    </div>
                                );
                            })}
                        </div>
                    </StepFormStyle>
                );
            })}
        </div>
    );
};

export default TestConnectionPopup;
